const PropTypes = require('prop-types');
// @ vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
// @ helpers
const { FormattedText } = require('core/i18n').i18n;
// @commons
const OKModal = require('components/commons/OKModal/OKModal');
const { OKButton } = require('components/commons/OKButton/OKButton');
// @components
const BrokerOrdersAndMovementsCancelContractDefaultModal = require('components/broker/brokerOrdersAndMovementsCancelContractDefaultModal/brokerOrdersAndMovementsCancelContractDefaultModal');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const WebappRender = require('components/conditionalRender/webappRender');

class BrokerOrdersAndMovementsCancelContractButton extends React.Component {

    constructor() {
        super();
        this.state = { modalOpened: false };
        this.handleModalToggle = this.handleModalToggle.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    UNSAFE_componentWillMount() {
        this.props.clearCancelAnOrderData();
    }

    handleModalToggle() {
        const { openMovementCancelationModal } = this.props;

        openMovementCancelationModal(!this.state.modalOpened)
        this.setState({
            modalOpened: !this.state.modalOpened
        });
    }

    handleSubmit() {
        const { immTransaction, requestCancelAnOrder, requestCancelCryptoOrder, history } = this.props;
        if (immTransaction.get('movementType') === 'CRYPTO') {
            requestCancelCryptoOrder(immTransaction, history);
        } else {
            requestCancelAnOrder(immTransaction, history);
        }
    }

    render() {
        const {
            originalIndex,
            immTransaction,
            immOrderCancel,
            isSignaturePatternLoading,
            requestCancelAnOrder,
            largeConfirmationModal
        } = this.props;

        const primaryButtonLoading = immOrderCancel.get('inProgress') || isSignaturePatternLoading;

        const modalContent = (
            <BrokerOrdersAndMovementsCancelContractDefaultModal
                immTransactionmodalContent={immTransaction}
                immTransaction={immTransaction}
                immOrderCancel={immOrderCancel}
                requestCancelAnOrder={requestCancelAnOrder}
                showAsLarge={largeConfirmationModal}
            />
        );

        return (
            <div>
                <ContactCenterRender>
                    <OKModal
                        content={modalContent}
                        footerType="navigation"
                        isOpen={this.state.modalOpened && !immOrderCancel.get('success')}
                        onCloseCallback={this.handleModalToggle}
                        onSecondaryButtonClick={this.handleModalToggle}
                        secondaryButtonText="broker-ordersAndMovementsCancelOperationModalClose"
                        title="broker-ordersAndMovementsCancelOperationModalDetailTitle"
                        primaryButtonCustom=""
                    />
                </ContactCenterRender>
                <WebappRender>
                    <OKModal
                        content={modalContent}
                        footerType="navigation"
                        isOpen={this.state.modalOpened && !immOrderCancel.get('success')}
                        onCloseCallback={this.handleModalToggle}
                        onPrimaryButtonClick={this.handleSubmit}
                        onSecondaryButtonClick={this.handleModalToggle}
                        primaryButtonLoading={primaryButtonLoading}
                        primaryButtonText="broker-ordersAndMovementsCancelOperationModalApply"
                        secondaryButtonText="broker-ordersAndMovementsCancelOperationModalClose"
                        title="broker-ordersAndMovementsCancelOperationModalDetailTitle"
                    />
                </WebappRender>
                <OKButton
                    id={`lnkContractActivityCancel${originalIndex}`}
                    modifier="secondary"
                    onClick={this.handleModalToggle}
                >
                    <FormattedText value="broker-contractActivityCancel" />
                </OKButton>
            </div>
        );
    }

}

BrokerOrdersAndMovementsCancelContractButton.propTypes = {
    originalIndex: PropTypes.number.isRequired,
    immTransaction: PropTypes.object.isRequired,
    immOrderCancel: PropTypes.object.isRequired,
    isSignaturePatternLoading: PropTypes.bool.isRequired,
    clearCancelAnOrderData: PropTypes.func.isRequired,
    requestCancelAnOrder: PropTypes.func.isRequired,
    requestCancelCryptoOrder: PropTypes.func.isRequired,
    openMovementCancelationModal: PropTypes.func.isRequired,
    largeConfirmationModal: PropTypes.bool.isRequired,
    history: PropTypes.object.isRequired,
}

module.exports = withRouter(BrokerOrdersAndMovementsCancelContractButton);
